/* WEP chrome – header height var, sticky-on-scroll-up, mobile drawer,
   mega-menu toggles, and footer accordions on mobile. No dependencies. */
(function () {
  'use strict';

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  var desktop = window.matchMedia('(min-width: 1200px)');

  function initHeader(wrap) {
    if (!wrap || wrap._wep) return;
    wrap._wep = true;
    var section = wrap.closest('.shopify-section') || wrap;
    var nav = wrap.querySelector('.wep-nav');
    var openBtn = wrap.querySelector('[data-wep-nav-open]');
    var scrim = wrap.querySelector('.wep-nav__scrim');

    /* --header-height lets an overlay hero slide under the floating bar */
    function setHeight() {
      if (wrap.classList.contains('is-stuck')) return;
      document.documentElement.style.setProperty('--header-height', wrap.offsetHeight + 'px');
    }
    setHeight();
    if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(wrap);

    /* sticky: flush bar once scrolled, hide on scroll down, show on scroll up */
    if (wrap.hasAttribute('data-sticky')) {
      var last = window.scrollY, ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY, h = section.offsetHeight;
          wrap.classList.toggle('is-stuck', y > h);
          if (!document.body.classList.contains('wep-nav-open')) {
            wrap.classList.toggle('is-hidden', y > h * 2 && y > last);
          }
          last = y;
          ticking = false;
        });
      }, { passive: true });
    }

    /* drawer */
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('wep-nav-open', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open);
      if (scrim) scrim.hidden = !open;
      if (open) { var c = nav.querySelector('.wep-nav__close'); if (c) c.focus(); }
      else if (openBtn) openBtn.focus();
    }
    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    $$('[data-wep-nav-close]', wrap).forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (nav.classList.contains('is-open')) setOpen(false);
      $$('.wep-nav__item.is-open', wrap).forEach(function (li) { toggleItem(li, false); });
    });
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (a && nav.classList.contains('is-open')) setOpen(false);
    });
    desktop.addEventListener('change', function () { if (nav.classList.contains('is-open')) setOpen(false); });

    /* mega menus: hover on desktop (CSS), click to toggle everywhere */
    function toggleItem(li, open) {
      li.classList.toggle('is-open', open);
      var b = li.querySelector('[data-wep-mega-toggle]');
      if (b) b.setAttribute('aria-expanded', open);
    }
    $$('[data-wep-mega-toggle]', wrap).forEach(function (btn) {
      var li = btn.closest('.wep-nav__item');
      btn.addEventListener('click', function () {
        var open = !li.classList.contains('is-open');
        if (desktop.matches) $$('.wep-nav__item.is-open', wrap).forEach(function (x) { if (x !== li) toggleItem(x, false); });
        toggleItem(li, open);
      });
      li.addEventListener('mouseleave', function () { if (desktop.matches) toggleItem(li, false); });
    });
    document.addEventListener('click', function (e) {
      if (!desktop.matches || wrap.contains(e.target)) return;
      $$('.wep-nav__item.is-open', wrap).forEach(function (li) { toggleItem(li, false); });
    });
  }

  function initFooter(root) {
    var cols = $$('.wep-ftr__col', root);
    if (!cols.length) return;
    function sync() {
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      cols.forEach(function (d) { if (mobile) d.removeAttribute('open'); else d.setAttribute('open', ''); });
    }
    sync();
    window.matchMedia('(max-width: 989px)').addEventListener('change', sync);
  }

  function init(root) {
    root = root || document;
    $$('[data-wep-header]', root).forEach(initHeader);
    initFooter(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Free consultation popup: opened by any [data-wep-quote-open] (the header button).
   The form sits in a <template>; the form CSS/JS and reCAPTCHA load on the first open. */
(function () {
  'use strict';
  if (window._wepQuote) return;
  window._wepQuote = true;

  var ready, compact = window.matchMedia('(max-width: 599px), (orientation: landscape) and (max-height: 500px)');
  function load(dlg) {
    var css = dlg.getAttribute('data-css'), js = dlg.getAttribute('data-js'), jobs = [];
    if (css && !document.querySelector('link[href^="' + css.split('?')[0] + '"]')) {
      jobs.push(new Promise(function (res) {
        var l = document.createElement('link');
        l.rel = 'stylesheet'; l.href = css; l.onload = res; l.onerror = res;
        document.head.appendChild(l);
      }));
    }
    if (!window.WEPSections && js) {
      jobs.push(new Promise(function (res) {
        var s = document.createElement('script');
        s.src = js; s.onload = res; s.onerror = res;
        document.head.appendChild(s);
      }));
    }
    return Promise.all(jobs);
  }
  function mount(dlg) {
    var slot = dlg.querySelector('[data-wep-quote-slot]'), tpl = dlg.querySelector('template[data-wep-quote-template]');
    if (!slot || !tpl) return;
    if (!slot.firstElementChild) {
      slot.appendChild(tpl.content.cloneNode(true));
      if (window.WEPSections) window.WEPSections.init(slot);
      // reCAPTCHA only auto-renders widgets that existed when its script loaded. If it is already on the page
      // (another form), render this one ourselves, once, after anything queued ahead of us has run.
      var box = slot.querySelector('.g-recaptcha');
      if (box && window.grecaptcha && typeof grecaptcha.ready === 'function') {
        grecaptcha.ready(function () {
          if (box.childElementCount) return;
          try { grecaptcha.render(box, { sitekey: box.getAttribute('data-sitekey') }); } catch (e) {}
        });
      }
    }
    var first = slot.querySelector('input[name="name"]');
    /* On phones the panel opens without the keyboard; the keyboard appears when a field is tapped. */
    if (first && dlg.open && !compact.matches) first.focus();
  }
  /* Optional enquiry context: [data-wep-quote-context="BigCommerce Theme Customization"] on the opening element is appended to the
     lead source label (data-label) of the popup form. It never touches the visitor's fields; opening without context restores the base label. */
  function applyContext(dlg, ctx) {
    var f = dlg.querySelector('[data-wep-quote-slot] form[data-wep-form]');
    if (!f) return;
    if (!f.hasAttribute('data-base-label')) f.setAttribute('data-base-label', f.getAttribute('data-label') || '');
    var base = f.getAttribute('data-base-label');
    f.setAttribute('data-label', ctx ? (base ? base + ' - ' + ctx : ctx) : base);
  }
  /* Keep the phone panel inside the visible screen: its height follows the visual viewport and it sits above the keyboard. */
  function track(dlg) {
    var vv = window.visualViewport;
    if (!vv || dlg._wepVv) return;
    dlg._wepVv = function () {
      dlg.style.setProperty('--wep-vv-h', vv.height + 'px');
      dlg.style.setProperty('--wep-qm-kb', Math.max(0, window.innerHeight - vv.height - vv.offsetTop) + 'px');
    };
    vv.addEventListener('resize', dlg._wepVv); vv.addEventListener('scroll', dlg._wepVv);
    dlg._wepVv();
  }
  function untrack(dlg) {
    var vv = window.visualViewport;
    if (!vv || !dlg._wepVv) return;
    vv.removeEventListener('resize', dlg._wepVv); vv.removeEventListener('scroll', dlg._wepVv);
    dlg._wepVv = null; dlg.style.removeProperty('--wep-vv-h'); dlg.style.removeProperty('--wep-qm-kb');
  }
  function unlock() { document.documentElement.classList.remove('wep-qm-open'); }
  function open(ctx) {
    var dlg = document.getElementById('wep-quote-modal');
    if (!dlg || typeof dlg.showModal !== 'function') return false;
    if (!dlg.open) dlg.showModal();
    if (!dlg._wepBound) {
      dlg._wepBound = true;
      dlg.addEventListener('close', function () { unlock(); untrack(dlg); });
      dlg.addEventListener('focusin', function (e) {
        if (compact.matches && e.target.matches && e.target.matches('input, textarea')) setTimeout(function () { e.target.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 300);
      });
    }
    if (compact.matches) track(dlg);
    document.documentElement.classList.add('wep-qm-open');
    ready = ready || load(dlg);
    ready.then(function () { mount(dlg); applyContext(dlg, ctx); });
    return true;
  }

  /* Page call-to-action links that used to scroll down to the on-page form (#contact, #audit, #review, #quick_quote,
     #wep-contact-form) open this popup instead. The link's own text becomes the enquiry context. If the popup cannot
     open, the link keeps working as a normal anchor. */
  var FORM_ANCHOR = /^#(contact|audit|review|quick_quote|wep-contact-form)$/;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!FORM_ANCHOR.test(a.getAttribute('href')) || a.hasAttribute('data-wep-quote-open') || a.closest('#wep-quote-modal')) return;
    var ctx = (a.getAttribute('data-wep-quote-context') || a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    var drawer = document.body.classList.contains('wep-nav-open') && document.querySelector('.wep-nav__close');
    if (open(ctx)) { e.preventDefault(); if (drawer) drawer.click(); }
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-wep-quote-open]');
    if (t) {
      var drawer = document.body.classList.contains('wep-nav-open') && document.querySelector('.wep-nav__close');
      if (open(t.getAttribute('data-wep-quote-context'))) { e.preventDefault(); if (drawer) drawer.click(); }
      return;
    }
    var dlg = document.getElementById('wep-quote-modal');
    if (!dlg || !dlg.open) return;
    if (e.target === dlg || (e.target.closest && e.target.closest('[data-wep-quote-close]'))) { dlg.close(); unlock(); }
  });
})();

/* Mobile floating button (.wep-mbar): hidden while the hero's first button is on screen, shown once that button has scrolled off the top.
   Pages without a hero show it after 500px of scrolling. Without JS the button stays visible. */
(function () {
  var bar = document.querySelector('.wep-mbar');
  /* Pages without their own bar (portfolio, case studies, home...) get the same button, built here. */
  if (!bar && !/thank-you/.test(location.pathname)) {
    bar = document.createElement('div');
    bar.className = 'wep-mbar wep-mbar--auto';
    bar.innerHTML = '<a class="button button--primary" href="#contact" data-wep-quote-context="Website enquiry">Discuss My Project</a>';
    document.body.appendChild(bar);
  }
  if (!bar) return;
  document.documentElement.classList.add('wep-mbar-js');
  function set(on) { bar.classList.toggle('is-visible', on); }
  var hero = document.querySelector('.wep-s-hero');
  var cta = hero && (hero.querySelector('.button') || hero);
  function update() {
    var r = cta && cta.getBoundingClientRect();
    set(r && r.height ? r.bottom < 0 : window.scrollY > 500);
  }
  function onScroll() { update(); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

/* Portfolio rows on phones: pin the logo only when the row's text runs longer than most of a screen
   (.wpj-row--long); short rows scroll normally. Re-measured after images load and on resize. */
(function () {
  var rows = [].slice.call(document.querySelectorAll('.wpj-row'));
  if (!rows.length) return;
  var mq = window.matchMedia('(max-width: 749px)');
  function mark() {
    rows.forEach(function (row) {
      var kids = [].slice.call(row.querySelectorAll('.wpj-row__body > :not(.wpj-row__logo):not(.wpj-row__word):not(.wpj-row__title)'));
      var long = false;
      if (mq.matches && kids.length) {
        var top = kids[0].getBoundingClientRect().top, bottom = kids[kids.length - 1].getBoundingClientRect().bottom;
        long = bottom - top > window.innerHeight * 0.5;
      }
      row.classList.toggle('wpj-row--long', long);
    });
  }
  mark();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(mark);
  window.addEventListener('load', mark);
  window.addEventListener('resize', mark);
  if (mq.addEventListener) mq.addEventListener('change', mark);
})();
